import 'whatwg-fetch';

function isJSONResponse(response) {
  const contentType = response.headers.get('content-type');
  return (contentType && contentType.indexOf('application/json') !== -1)
}

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  if (isJSONResponse(response)) {
    return response.json();
  }
  // console.warn("Non JSON response!"); // eslint-disable-line
  return Promise.resolve({});
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  return parseJSON(response).then((RespJSON) => {
    const error = new Error(response.statusText);
    error.response = response;
    error.json = RespJSON;
    throw error;
  });
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./webapp/utils/fetch.js